module.exports = __webpack_public_path__ + "static/media/playButton.bee8169c.svg";